import React from 'react';
import {Alert} from '@mui/material';

export default function DomainAlert({severity, children}) {
    return <Alert severity={severity} variant="filled" role={severity === 'success' ? 'status' : 'alert'}
        sx={theme => {
            const background = theme.palette[severity].dark;
            return {
                mb: 2, bgcolor: background, color: theme.palette.getContrastText(background), borderRadius: '8px',
                '& .MuiAlert-icon': {color: 'inherit', opacity: 1},
                '& .MuiAlert-message': {whiteSpace: 'normal', overflowWrap: 'anywhere'}
            };
        }}>{children}</Alert>;
}
